(function (angular, app) {
   "use strict";

   angular.module(app.modules.member.name)
      .controller(app.modules.member.routes.handicaplookup.controller, HandicapLookupController);
      
   HandicapLookupController.$inject = ["$scope",  "$q", "$window", "$timeout", "$sce", "ngDialog", "$routeParams"
      , app.modules.member.services.search
      , app.modules.member.services.detail
      , app.modules.group.services.groups
      , app.modules.common.constants.appmessaging
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.common.constants.regionlist
      , app.modules.ui.services.alerts
   ];
   
   function HandicapLookupController($scope, $q, $window, $timeout, $sce, ngDialog, $routeParams
      , ggMemberSearchSvc
      , ggMemberDetailSvc
      , ggGroupSvc
      , ggMessaging
      , ggFunctions
      , ggStorage
      , ggRegions
      , ggAlertSvc
   ) {

      // Assign this to object so it can be updated from watcher
      var ctrl = this;
     
      $scope.Temp = {
         isLoaded: true
         , window: ggFunctions.fetchWindowSize()
         , isSwiper: false
         , scrollLimit: 10
         , isScrolling: false
      }

      // Scope
      $scope.Member = null;  // .Groups, .Clubs .Handicap
      $scope.PopupAlert = new ggAlertSvc.popup;
               
      $scope.View = {
         tabs: {
            current : 1
            , types: {
               search: 1
               , following: 2
               , partners: 3
               , groups: 4
               , clubs : 5
            }
            , isActive: function (tab) {
               return tab == $scope.View.tabs.current;
            }
            , select: function (tab) {

               app.Member.Session.bookmark.handicaplookup.tab = tab;
               if (tab == $scope.View.tabs.types.following) {
                  $scope.Content.following.fetch();
               }
               if (tab == $scope.View.tabs.types.partners) {
                  $scope.Content.partners.fetch();
               }
               if (tab == $scope.View.tabs.types.groups) {
                  $scope.Content.groups.fetchList();
               }
               if (tab == $scope.View.tabs.types.clubs) {
                  $scope.Content.clubs.fetchList();
               }
               
               $scope.View.tabs.current = tab;
            }
         }
      }
      
      $scope.Content = {
          init: function (tab) {
              if (!tab) {
                  tab = app.Member.Session.bookmark.handicaplookup.tab || $scope.View.tabs.current;
              }
            
              $scope.View.tabs.select(tab);

            if (tab == $scope.View.tabs.types.search) {
               $scope.Content.search.results = app.Member.Session.bookmark.handicaplookup.results;
               if ($scope.Content.search.results.length > 0) {
                  $scope.Content.search.isSearch = true;
               }
            }
         }
         , search: {
            results: []
            , isDirty: false
            , isSearch: false
            , reset: function () {
               $scope.Content.search.isSearch = false;
               $scope.Content.search.results = [];
            }
            , regionlist: {
               data: ggRegions //app.data.Regions
            }
            , form: {
               name: ""
               , regioncode: ""
            }
            , fetch: function (isValid) {
               $scope.Content.search.isDirty = true;
               if (isValid) {
                  ggFunctions.toggleProcessing(true);
                   ggMemberSearchSvc.search.fetchHandicapSearch($scope.Content.search.form).then(function (data) {
                     if (data && data.status == "200") {
                        $scope.Content.search.results = data.data.value;
                        app.Member.Session.bookmark.handicaplookup.results = data.data.value;
                     }

                  }).finally(function () {
                     $scope.Content.search.isSearch = true;
                     ggFunctions.toggleProcessing(false);
                  })
                  ;
               }
            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.search.swipe.selected = id;
                  $scope.Content.search.swipe.isFollowing = false;
                  if ($scope.f.isFollowing(id)) {
                     $scope.Content.search.swipe.isFollowing = true;
                  }

               }
               , right: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.search.swipe.selected = 0;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.search.swipe.selected
               }
            }
         }
         , following: {
            results: []
            , isDirty: false
            , isSearch: false
            , reset: function () {
               $scope.Content.following.isSearch = false;
               $scope.Content.following.results = [];
            }
            , fetch: function (isRefresh) {
               var processData = function (results) {

                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.lastName;
                        var d2 = b.lastName;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.following.results = results
                  $scope.Content.following.isLoaded = true;
                  return $q.when();
               }

               return app.Member.Network.Data.Friends.fetch(true).then(function (data) {
                  return processData(data);
               }).finally(function () {
                  ggFunctions.toggleProcessing(false);
               });

            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , isPartner : false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.following.swipe.selected = id;
                  $scope.Content.following.swipe.isFollowing = true;
                  if (!$scope.f.isFollowing(id)) {
                     $scope.Content.following.swipe.isFollowing
                  }
                  $scope.Content.following.swipe.isPartner = false;
                  if ($scope.f.isPartner(id)) {
                     $scope.Content.following.swipe.isPartner = true;
                  }
               }
               , right: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.following.swipe.selected = 0;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.following.swipe.selected
               }
            }

         }
         , partners: {
            results: []
            , isDirty: false
            , isSearch: false
            , isPartner: true
            , reset: function () {
               $scope.Content.partners.isSearch = false;
               $scope.Content.partners.results = [];
            }
            , fetch: function (isRefresh) {
               var processData = function (results) {

                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.name;
                        var d2 = b.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.partners.results = results
                  $scope.Content.partners.isLoaded = true;
                  return $q.when();
               }

               var isCurrent = ggStorage.get(ggStorage.keys.members.partners.isCurrent);
               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.partners.data)) || [];

               if (isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0)) {
                  ggFunctions.toggleProcessing(true);
                  return app.Member.Network.Data.Partners.fetch(true).then(function (data) {
                     return processData(data);
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });
               } else {
                  return processData(storeData);
               }
            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.partners.swipe.selected = id;
                  $scope.Content.partners.swipe.isPartner = true;
                  if (!$scope.f.isPartner(id)) {
                     $scope.Content.partners.swipe.isPartner = false;
                  }

               }
               , right: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.partners.swipe.selected = 0;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.partners.swipe.selected
               }
            }
         }
         , groups: {
            groupList: []
            , fetchList: function () {
               var processData = function (results) {

                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.name;
                        var d2 = b.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.groups.groupList = results
                  return $q.when();
               }

               var isCurrent = ggStorage.get(ggStorage.keys.groups.my.isCurrent);
               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.my.data)) || [];

               if (!isCurrent || !storeData || (storeData && storeData.length == 0)) {
                  ggFunctions.toggleProcessing(true);
                  return app.Member.Network.Data.Groups.fetch(true).then(function (data) {
                     return processData(data);
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });
               } else {
                  return processData(storeData);
               }
            }
            , results: []
            , isDirty: false
            , isSearch: false
            , reset: function () {
               $scope.Content.groups.isSearch = false;
               $scope.Content.groups.results = [];
            }
            , form: {
               groupId : "0"
            }
            , fetch: function (isValid) {
               $scope.Content.groups.isDirty = true;
               if (isValid) {
                  ggCourseSearchSvc.search.fetchCourseSearch($scope.Content.groups.form).then(function (data) {
                     if (data && data.status == "200") {
                        $scope.Content.groups.results = data.data.value;
                     }

                  }).finally(function () {
                     $scope.Content.groups.isSearch = true;
                  })
                  ;
               }
            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.groups.swipe.selected = id;
                  $scope.Content.groups.swipe.isFollowing = false;
                  if ($scope.f.isFollowing(id)) {
                     $scope.Content.groups.swipe.isFollowing = true;
                  }

               }
               , right: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.groups.swipe.selected = 0;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.groups.swipe.selected
               }
            }
         }
         , clubs: {
            clubList: []
            , fetchList: function () {
               var processData = function (results) {

                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.name;
                        var d2 = b.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.groups.clubList = results
                  return $q.when();
               }

               var isCurrent = ggStorage.get(ggStorage.keys.clubs.my.isCurrent);
               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.clubs.my.data)) || [];

               if (!isCurrent || !storeData || (storeData && storeData.length == 0)) {
                  ggFunctions.toggleProcessing(true);
                  return app.Member.Network.Data.Clubs.fetch(true).then(function (data) {
                     return processData(data);
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });
               } else {
                  return processData(storeData);
               }
            }
            , results: []
            , isDirty: false
            , isSearch: false
            , reset: function () {
               $scope.Content.clubs.isSearch = false;
               $scope.Content.clubs.results = [];
            }
            , form: {
               clubId : "0"
            }
            , fetch: function (isValid) {
               $scope.Content.clubs.isDirty = true;
               if (isValid) {
                  ggCourseSearchSvc.search.fetchCourseSearch($scope.Content.clubs.form).then(function (data) {
                     if (data && data.status == "200") {
                        $scope.Content.clubs.results = data.data.value;
                     }

                  }).finally(function () {
                     $scope.Content.clubs.isSearch = true;
                  })
                  ;
               }
            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.clubs.swipe.selected = id;
                  $scope.Content.clubs.swipe.isFollowing = false;
                  if ($scope.f.isFollowing(id)) {
                     $scope.Content.clubs.swipe.isFollowing = true;
                  }

               }
               , right: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.clubs.swipe.selected = 0;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.clubs.swipe.selected
               }
            }
         }
         , selectMember : function(member) {
            ggFunctions.goToPage(app.modules.member.routes.memberdetail.path + "?memberId=" + member.id);
         }
         , refresh: function () {
            if ($scope.View.tabs.current == $scope.View.tabs.types.following) {
               $scope.Content.following.fetch(true);
            }
            if ($scope.View.tabs.current == $scope.View.tabs.types.partners) {
               $scope.Content.partners.fetch(true);
            }
         }
      }
      

      // limiting scroll height
      angular.element($window).bind("scroll", function () {
         var windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
         var body = document.body, html = document.documentElement;
         var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
         var windowBottom = windowHeight + window.pageYOffset;
         if (windowBottom >= docHeight && !$scope.Temp.isScrolling) {
            $scope.f.scrollLimit();
         }
      });

      // Functions
      $scope.f = {
         isSwiper: function () {
            $scope.Temp.isSwiper = true;
            $timeout(function () {
               $scope.Temp.isSwiper = false
            }, 500);
         }
         , scrollLimit: function () {

            $scope.Temp.isScrolling = true;
            $scope.$apply();
            $timeout(function () {
               $scope.Temp.scrollLimit = $scope.Temp.scrollLimit + 10;
               $scope.Temp.isScrolling = false;
               $scope.$apply();
            }, 100);
         }
         , isPartner: function (memberId) {
            return app.Member.Network.Data.Partners.isFollowing(memberId);
         }
         , isFollowing: function (memberId) {
            return app.Member.Network.Data.Friends.isFollowing(memberId);
         }
         , followMember: function (member) {
            app.Member.Network.Data.Friends.follow(member).then(function (data) {
               if (data) {
                  if ($scope.View.tabs.current == $scope.View.tabs.types.following) {
                     $scope.Content.following.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.partners) {
                     $scope.Content.partners.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.groups) {
                     $scope.Content.groups.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.clubs) {
                     $scope.Content.clubs.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                     $scope.Content.search.swipe.right(member.id);
                  }
               }
            });
         }
         , unFollowMember: function (member) {
            app.Member.Network.Data.Friends.unfollow(member).then(function (data) {
               if (data) {
                  $scope.Content.following.results = data;
                  if ($scope.View.tabs.current == $scope.View.tabs.types.following) {
                     $scope.Content.following.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.partners) {
                     $scope.Content.partners.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.groups) {
                     $scope.Content.groups.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.clubs) {
                     $scope.Content.clubs.swipe.right(member.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                     $scope.Content.search.swipe.right(member.id);
                  }
               }
            });
         }
         , addPartner: function (member) {
            app.Member.Network.Data.Partners.follow(member).then(function (data) {
               if (data) {
                  if ($scope.f.isPartner(member.id)) {
                     if ($scope.View.tabs.current == $scope.View.tabs.types.following) {
                        $scope.Content.following.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.partners) {
                        $scope.Content.partners.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.groups) {
                        $scope.Content.groups.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.clubs) {
                        $scope.Content.clubs.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                        $scope.Content.search.swipe.right(member.id);
                     }
                  }
               }
            });
         }
         , removePartner: function (member) {
            app.Member.Network.Data.Partners.unfollow(member).then(function (data) {
               if (data) {
                  if (!$scope.f.isPartner(member.id)) {
                     if ($scope.View.tabs.current == $scope.View.tabs.types.following) {
                        $scope.Content.following.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.partners) {
                        $scope.Content.partners.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.groups) {
                        $scope.Content.groups.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.clubs) {
                        $scope.Content.clubs.swipe.right(member.id);
                     }
                     if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                        $scope.Content.search.swipe.right(member.id);
                     }
                  }
               }
            });
         }
      }

      var tab;
      if ($routeParams.following) {
          tab = $scope.View.tabs.types.following;
      }
      $scope.Content.init(tab);
    

   }
}(angular, app));

